

















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { $t } from "@/lib/i18nHelpers";
import { FormField, FormFields } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "BasePromptConfirmation",
  components: { BaseConfirm, BaseButton, BaseForm },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    title: { type: String as PropType<TranslateResult> },
    successButtonName: { type: String as PropType<TranslateResult>, required: true },
    inputProps: { type: Object as () => Partial<FormField> },
  },
  setup(props, { emit }) {
    const values = ref({ formInput: props.inputProps?.value || "" });
    const isValid = ref(false);
    const manualValidation = ref(() => Promise.resolve(false));
    const fields = computed<FormFields>(() => [
      {
        class: ["mb-5"],
        name: "formInput",
        autofocus: false,
        autocomplete: "off",
        rulesMessages: {
          required: $t("This field is required"),
        },
        ...props.inputProps,
      },
    ]);

    const onSubmit = async () => {
      isValid.value = await manualValidation.value();
      if (isValid.value && !props.loading) {
        emit("submit", values.value.formInput, () => (values.value.formInput = ""));
      }
    };

    return {
      fields,
      values,
      manualValidation,
      isValid,
      onSubmit,
    };
  },
});
